import { AiOutlineCloseCircle } from "react-icons/ai";
import { useCurrentRefinements } from "react-instantsearch-hooks-web";

function CurrentRefinements({ source }) {
  const { items, canRefine, refine } = useCurrentRefinements();
  function kFormatter(num) {
    return Math.abs(num) > 999999
      ? Math.sign(num) * (Math.abs(num) / 1000000).toFixed(1) + "M"
      : Math.sign(num) * Math.abs(num);
  }

  return (
    <>
      {items.length > 0 ? (
        <div
          className={
            " flex w-full flex-row flex-wrap items-center  gap-y-0 space-x-0 space-y-2  bg-white px-5 py-0 lg:space-y-0 lg:bg-white " +
            (source === "TOWN" ? " mb-3 lg:px-0 " : " pt-2 lg:px-32")
          }
        >
          {items.map((ref) => {
            return (
              <div
                key={ref.label}
                className="  flex flex-row items-center  space-x-3 rounded-full bg-blue-100 py-1 pl-5 pr-2 font-medium capitalize shadow-sm"
              >
                {ref.label === "propertyTown.townName" ? (
                  <span className=" select-none text-sm font-medium">
                    {" "}
                    Town
                  </span>
                ) : null}

                {ref.label === "propertyArea.areaName" ? (
                  <span className=" select-none text-sm font-medium">
                    {" "}
                    Area
                  </span>
                ) : null}

                {ref.label === "propertyType" ? (
                  <span className=" select-none text-sm font-medium text-gray-900">
                    Home Type
                  </span>
                ) : null}
                {ref.label === "listingType" ? (
                  <span className=" select-none text-sm font-medium text-gray-900">
                    Market
                  </span>
                ) : null}
                {ref.label === "noOfBedrooms" ? (
                  <span className=" select-none text-sm font-medium text-gray-900">
                    Bedrooms
                  </span>
                ) : null}
                {ref.label === "noOfBathrooms" ? (
                  <span className=" select-none text-sm font-medium text-gray-900">
                    Bathrooms
                  </span>
                ) : null}
                {ref.label === "monthlyRent" || ref.label === "price" ? (
                  <span className=" select-none text-sm font-medium text-gray-900">
                    Price
                  </span>
                ) : null}

                {ref.refinements.map((el) => {
                  //console.log(el);
                  return (
                    <div
                      key={el.value}
                      className="group flex cursor-pointer flex-row items-center  space-x-2 rounded-full bg-ula-blue px-4 py-1 text-sm text-white"
                    >
                      {el.attribute === "monthlyRent" ||
                      el.attribute === "price" ? (
                        <span className="  select-none text-blue-100 ">
                          {" "}
                          {el.operator === ">=" ? "min" : "max"} Kshs{" "}
                          {el.value > 999999
                            ? kFormatter(el.value)
                            : Intl.NumberFormat().format(el.value)}
                        </span>
                      ) : null}
                      {el.attribute === "listingType" ? (
                        <span className="  select-none capitalize text-blue-100 ">
                          {el.value.toLowerCase()}
                        </span>
                      ) : null}
                      {el.attribute === "propertyArea.areaName" ? (
                        <span className="  select-none capitalize text-blue-100 ">
                          {el.value.toLowerCase()}
                        </span>
                      ) : null}
                      {el.attribute === "propertyTown.townName" ? (
                        <span className="  select-none capitalize text-blue-100 ">
                          {el.value.toLowerCase()}
                        </span>
                      ) : null}
                      {el.attribute === "propertyType" ? (
                        <span className="  select-none capitalize text-blue-100 ">
                          {el.value.toLowerCase()}
                        </span>
                      ) : null}
                      {el.attribute === "noOfBedrooms" ? (
                        <span className="  select-none capitalize text-blue-100 ">
                          {el.value.toLowerCase()}
                        </span>
                      ) : null}
                      {el.attribute === "noOfBathrooms" ? (
                        <span className="  select-none capitalize text-blue-100 ">
                          {el.value.toLowerCase()}
                        </span>
                      ) : null}
                      <AiOutlineCloseCircle
                        onClick={() => {
                          refine(el);
                        }}
                        className=" text-blue-200 group-hover:text-blue-100"
                      />
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      ) : null}
    </>
  );
}

export default CurrentRefinements;
